import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from '../../Assets/Images/AmericanLogo.png';
import loginBG from "../../Assets/Images/loginBG.jpg";

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!username || !password) {
            setErrorMessage("Username and password are required.");
            return;
        }

        try {
            const response = await axios.post(`${API_URL}/api/auth/login`, { username, password });
            const { token } = response.data;
            localStorage.setItem("authToken", token);
            navigate("/dashboard");
        } catch (error) {
            if (error.response) {
                setErrorMessage(error.response.data.error);
            } else if (error.request) {
                setErrorMessage("Network error. Please check your connection.");
            } else {
                setErrorMessage("Something went wrong. Please try again later.");
            }
        }
    };

    const styles = {
        container: {
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontFamily: "Arial, sans-serif",
            overflow: "hidden",
        },
        background: {
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            background: `url(${loginBG}) no-repeat center center fixed`,
            backgroundSize: "cover",
            filter: "brightness(0.4)",
            zIndex: -2,
        },
        overlay: {
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: -1,
        },
        card: {
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            padding: 30,
            borderRadius: 15,
            boxShadow: "0 8px 32px rgba(31, 38, 135, 0.2)",
            width: "100%",
            maxWidth: 400,
            textAlign: "center",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            zIndex: 1,
        },
        logoContainer: {
            marginBottom: 20,
        },
        logo: {
            maxWidth: 150,
            marginBottom: 10,
        },
        error: {
            color: "#ff6b6b",
            fontSize: 14,
            marginBottom: 15,
        },
        formGroup: {
            marginBottom: 15,
            textAlign: "left",
            color: "#fff",
        },
        label: {
            fontSize: 14,
            color: "#eee",
        },
        input: {
            width: "100%",
            padding: 10,
            fontSize: 16,
            border: "1px solid rgba(255, 255, 255, 0.4)",
            borderRadius: 5,
            background: "rgba(255, 255, 255, 0.2)",
            color: "#fff",
            boxSizing: "border-box",
        },
        inputFocus: {
            borderColor: "#53c9e7",
            outline: "none",
            background: "rgba(255, 255, 255, 0.3)",
        },
        button: {
            backgroundColor: "#53c9e7",
            color: "white",
            padding: 10,
            fontSize: 16,
            border: "none",
            borderRadius: 5,
            cursor: "pointer",
            width: "100%",
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.background}></div>
            <div style={styles.overlay}></div>
            <div style={styles.card}>
                <div style={styles.logoContainer}>
                    <img src={logo} alt="Logo" style={styles.logo} />
                </div>

                {errorMessage && <p style={styles.error}>{errorMessage}</p>}

                <form onSubmit={handleLogin}>
                    <div style={styles.formGroup}>
                        <label htmlFor="username" style={styles.label}>Username</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            style={styles.input}
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label htmlFor="password" style={styles.label}>Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={styles.input}
                        />
                    </div>
                    <button type="submit" style={styles.button}>Login</button>
                </form>
            </div>
        </div>
    );
}

export default Login;
